import { render, staticRenderFns } from "./7thAnniversaryPrize.vue?vue&type=template&id=66842bb0&scoped=true&"
import script from "./7thAnniversaryPrize.vue?vue&type=script&lang=js&"
export * from "./7thAnniversaryPrize.vue?vue&type=script&lang=js&"
import style0 from "./7thAnniversaryPrize.vue?vue&type=style&index=0&id=66842bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66842bb0",
  null
  
)

export default component.exports